function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M451.026,282.919h-75.984c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h27.715l-95.94,95.938 c-7.811,7.811-7.811,20.474,0,28.284c7.81,7.81,20.473,7.812,28.284,0.001l95.941-95.939v27.715c0,11.046,8.954,20,20,20 c11.046,0,20-8.954,20-20v-75.999c0-0.003,0-0.006,0-0.009C471.036,292.042,462.204,282.911,451.026,282.919z"
}), React.createElement("path", {
  d: "M492.001,59h-118c-11.046,0-20,8.954-20,20v98h-98c-11.045,0-20,8.954-20,20v98h-98c-11.046,0-20,8.954-20,20v98H20 c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h118.001c5.304,0,10.392-2.107,14.142-5.858 c3.751-3.75,5.858-8.838,5.858-14.142L158,335h98.001c5.304,0,10.392-2.107,14.142-5.858c3.751-3.75,5.858-8.838,5.858-14.142 L276,217h98c5.305,0,10.392-2.107,14.142-5.858c3.751-3.75,5.858-8.838,5.858-14.142l-0.001-98H492c11.046,0,20-8.954,20-20 S503.046,59,492.001,59z"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      "enableBackground": "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

export default __webpack_public_path__ + "static/media/stairs.20788dc5.svg";
export { SvgComponent as ReactComponent };